import React from "react";

const TotalSection = ({
  order,
  total,
  refund,
  totalPromoCodeAmount,
  deliveryFee,
  subTotal
}) => (
  <div className="white-bg mt-10px padding-box total">
    <ul>
      {(order.usedPoints && (
        <li className="d-flex justify-content-between">
          <p>Local E eCoins Spent</p>
          <p className="bold">-{order.usedPoints} eCoins.</p>
        </li>
      )) || <noscript />}
      <li className="d-flex justify-content-between">
        <p>Subtotal</p>
        <p className="bold">£{parseFloat(subTotal).toFixed(2)}</p>
      </li>
      {(order.smallAmountFee && (
        <li className="d-flex justify-content-between">
          <p>Small Basket Fee</p>
          <p className="bold">£{parseFloat(order.smallAmountFee).toFixed(2)}</p>
        </li>
      )) || <noscript />}
      <li className="d-flex justify-content-between">
        <p>Delivery Charge</p>
        <p className="bold">£{parseFloat(deliveryFee).toFixed(2)}</p>
      </li>
      {(order.totalPromoCodeAmount && (
        <li className="d-flex justify-content-between">
          <p>Promo</p>
          <p className="bold">£{parseFloat(totalPromoCodeAmount).toFixed(2)}</p>
        </li>
      )) || <noscript />}
      <li className="d-flex justify-content-between last">
        <p>Total</p>
        <p className="bold">£{parseFloat(total).toFixed(2)}</p>
      </li>
      {(refund && refund.amount && (
        <li className="d-flex justify-content-between">
          <p>Refund</p>
          <p className="bold">£{parseFloat(refund.amount).toFixed(2)}</p>
        </li>
      )) || <noscript />}
    </ul>
  </div>
);

export default TotalSection;
